import { Text } from '@chakra-ui/react';
import React from 'react';

import { Alert } from '~/packages/common-frontend/components/Alert';

export const LoanAccountNotFoundAlert = () => (
  <Alert status="error">
    <Text>Loan account not found</Text>
  </Alert>
);
